import { Select, Tooltip } from "antd"
import { PricingType, pricingTypeName } from "../../../../../common/constants"
import { getAvailablePricingTypes } from "./pricingTypeSelectorModel"

type Props = {
  value: PricingType
  onChange: (value: PricingType) => void
  canEditGroupFields: boolean
  isPricingLocked: boolean
  isApproved: boolean
  excludePerVisit?: boolean
}

const buildTooltipMessage = (isPricingLocked: boolean, isApproved: boolean) => {
  if (isPricingLocked) {
    return `This cannot be changed because there is an associated invoice.`
  }

  if (isApproved) {
    return 'This cannot be changed after being approved.'
  }

  return `This can only be changed at the group level.`
}

const PricingTypeSelector = ({ value, onChange, canEditGroupFields, isPricingLocked, isApproved, excludePerVisit = false }: Props) => {
  const disabled = !canEditGroupFields || isPricingLocked || isApproved

  const options = getAvailablePricingTypes(value, { excludePerVisitPricing: excludePerVisit })
    .map(value => ({ label: pricingTypeName(value), value }))

  const select = <Select
    options={options}
    value={value}
    onChange={onChange}
    disabled={disabled}
    popupMatchSelectWidth={false}
    showSearch
    optionFilterProp='label'
  />

  return disabled
    ? <Tooltip title={buildTooltipMessage(isPricingLocked, isApproved)}>{select}</Tooltip>
    : select
}

export default PricingTypeSelector
